import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=591b88cb&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=ts&"
export * from "./CommonCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=591b88cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b88cb",
  null
  
)

export default component.exports